var RequestV5 = (function () {
    function RequestV5(changed, actions) {
        if (changed === void 0) { changed = []; }
        if (actions === void 0) { actions = []; }
        this.Changed = changed;
        this.Actions = actions;
    }
    return RequestV5;
}());
export { RequestV5 };
